export const Types = {
    SAVE_LIST_USER: 'SAVE_LIST_USER',
    SAVE_LIST_ORDER_USER: 'SAVE_LIST_ORDER_USER',
    SAVE_DETAIL_SELLER: 'SAVE_DETAIL_SELLER',
    SET_RECORD: 'SET_RECORD'
}